/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';
import LineGraph from '../../graphs/base/LineGraph.js';
import AssignStudents from '../../wizard/create-class-steps/review-students.js';
import ClassScores from '../../class-scores-widget.js'
class AboutPanel extends React.Component {

    constructor(){
        super();
        this.state ={
            wordsLearnt:[]
        }
    }

    componentDidMount(){

    }

    componentWillMount(){

    }

    render(){

        const EditSubPanel = AssignStudents.component;

        return (
            <div>
                <div className="pmb-block m-5">
                    <ClassScores classID={this.props.data.classID}/>
                </div>
            </div>
        );
    }
}





export default {
    name: <FormattedMessage id={ 'ui-557' } defaultMessage={ 'Scores And Reports' }/>,
    component: AboutPanel
}


// WEBPACK FOOTER //
// ./src/components/profile/profile-tabs/class-scores-panel.js